import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT, Location, PlatformLocation } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  OnDestroy, OnInit,
  Renderer2,
  Type,
  ViewChild,
} from '@angular/core';
import { slideInUpOnEnterAnimation } from '@app/animation/slideDownToUp';
import { Subject } from 'rxjs';

import { DialogRef } from './../dialog-ref';
import { InsertionDirective } from './../insertion.directive';

@Component({
  selector: 'navaar-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  animations: [
    trigger('overlay', [
      state(':leave', style({

        opacity: 0
      })),
      state(':enter', style({

        opacity: 1
      })),
      transition('* => *', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ]),
    slideInUpOnEnterAnimation({ anchor: 'slidePopup' })
  ]
})
export class DialogComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(InsertionDirective) private readonly insertionPoint: InsertionDirective;
  private componentRef: ComponentRef<any>;
  public childComponentType: Type<any>;
  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private readonly document: Document,
    public readonly dialogRef: DialogRef,
    private readonly render: Renderer2,
    private readonly _location: PlatformLocation,
    private readonly location: Location
  ) { }

  ngOnInit(): void {
    this.render.setStyle(this.document.body, 'overflow', 'hidden');
    this._location.pushState(null, null, this.location.path() + '#modalOpened');
    this._location.onPopState(() => {
      this.dialogRef.close(null);
    })
  }

  ngAfterViewInit(): void {
    this.loadChildComponent(this.childComponentType);
    this.cd.detectChanges();
  }

  loadChildComponent(componentType: Type<any>): void {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
